import {AvsluttetPrissoknad, erFerdigbehandlet, Prissoknad} from "../api/prissoknader";
import {PlassSakInfo} from "../api/plassSaker";

export type SakInfo = {
    id: string
    navn: string
    dato: string
    type: 'PLASS_SØKNAD' | 'PLASS_TILBUD' | 'PRIS_SOKNAD' | 'PLASS_OPPSIGELSE' | 'PLASS_PERMISJONSSØKNAD'
}

function mapPrisSoknadToSakInfo(soknad: Prissoknad): SakInfo {
    return {
        id: soknad.brukerreferanse,
        navn: soknad.hovedsøkerFulltNavn,
        dato: soknad.innsendtdato,
        type: 'PRIS_SOKNAD',
    }
}

function mapPrisAvsluttetPrissoknadToSakInfo(soknad: AvsluttetPrissoknad): SakInfo {
    return {
        id: soknad.brukerreferanse,
        navn: '', //Har ikke navn på avsluttede pris søknader, kan ikke se at den brukes til noe p.t. så bare setter den til tom.
        dato: soknad.innsendtdato,
        type: 'PRIS_SOKNAD',
    }
}

function getPlassSakType(sakType: String): SakInfo['type'] {
  switch(sakType) {
    case 'SØKNAD':
      return 'PLASS_SØKNAD'
    case 'TILBUD':
      return 'PLASS_TILBUD'
    case 'OPPSIGELSE':
      return 'PLASS_OPPSIGELSE'
    case 'PERMISJONSSØKNAD':
      return 'PLASS_PERMISJONSSØKNAD'
    default:
      return 'PLASS_TILBUD'
  }
}

function mapPlassSakToSakInfo(sak: PlassSakInfo): SakInfo {
    return {
        id: sak.id.toString(),
        navn: sak.barnNavn,
        dato: sak.dato,
      type: getPlassSakType(sak.type)
    }
}

export function sorterAktuelleSakerPåDato(
    plassSaker: Array<PlassSakInfo>,
    prisSoknader: Array<Prissoknad>,
): Array<SakInfo> {
    const aktivePrissoknader = prisSoknader.filter((prissoknad) => !erFerdigbehandlet(prissoknad))
    const saker = plassSaker.map(mapPlassSakToSakInfo).concat(aktivePrissoknader.map(mapPrisSoknadToSakInfo))
    return sorterSakerPåDato(saker)
}

export function sorterAvsluttedeSakerPåDato(
    plassSaker: Array<PlassSakInfo>,
    prisSoknader: Array<Prissoknad>,
    prisAvsluttedeSoknader: Array<AvsluttetPrissoknad>
): Array<SakInfo> {
    const ferdigbehandletPrissoknader = prisSoknader.filter((prissoknad) => erFerdigbehandlet(prissoknad))

    const saker = plassSaker.map(mapPlassSakToSakInfo).concat(ferdigbehandletPrissoknader.map(mapPrisSoknadToSakInfo)).concat(prisAvsluttedeSoknader.map(mapPrisAvsluttetPrissoknadToSakInfo))
    return sorterSakerPåDato(saker)
}

function sorterSakerPåDato(saker: Array<SakInfo>): Array<SakInfo> {
    return saker.sort((a, b) => Date.parse(a.dato) < Date.parse(b.dato) ? 1 : -1)
}
